export const useGuestLogin = () => {
  const { setUser } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const deviceUdid = getDeviceUuid()
      const deviceType = DeviceType.WEB
      const res = await $api<LoginResponse>('/users/guest-login', {
        method: 'POST',
        body: {
          deviceUdid,
          deviceType,
        },
      })
      if (!res.userInfo) {
        res.userInfo = createGuestUser()
      }
      res.isGuest = true
      setUser(res)

      return res
    },
    onSuccess: () => {
      queryClient.resetQueries()
    },
  })
}
